"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

var colors = _interopRequireWildcard(require("./colors"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var defaultMuiTheme = (0, _styles.createMuiTheme)();
var spacing = defaultMuiTheme.spacing; // When material-ui implements custom palette colors, we'll add them here
// https://github.com/mui-org/material-ui/issues/13875

var palette = {
  primary: {
    main: colors.TEAL,
    dark: colors.TEAL_DARK,
    light: colors.TEAL_LIGHT,
    contrastText: colors.WHITE,
    lightContrastText: colors.TEAL_VERY_LIGHT
  },
  secondary: {
    main: colors.GOLD,
    dark: colors.GOLD_DARK,
    light: colors.GOLD_LIGHT,
    contrastText: colors.WHITE,
    lightContrastText: colors.WHITE
  },
  error: {
    main: colors.RED,
    light: colors.RED_LIGHT
  }
};
var theme = (0, _styles.createMuiTheme)({
  palette: palette,
  typography: {
    fontFamily: ['"Helvetica Neue"', 'Arial', 'Roboto', 'sans-serif'],
    h1: {
      fontSize: 46
    },
    h2: {
      fontSize: 35
    },
    h3: {
      fontSize: 24
    },
    h4: {
      fontSize: 18
    },
    h5: {
      fontSize: 16
    },
    body1: {
      fontSize: 14
    },
    subtitle1: {
      fontSize: 14
    },
    button: {
      fontSize: 14,
      textTransform: 'none'
    },
    caption: {
      fontSize: 10
    }
  },
  shape: {
    borderRadius: 2
  },
  props: {
    MuiButton: {
      color: 'primary',
      variant: 'contained'
    }
  },
  overrides: {
    MuiButton: {
      root: {
        padding: spacing(1, 2, 1, 2),
        borderRadius: '2px'
      },
      contained: {
        boxShadow: 'none'
      },
      outlined: {
        padding: [spacing(1) - 1, spacing(2) - 1, spacing(1) - 1, spacing(2) - 1].map(function (x) {
          return "".concat(x, "px");
        }).join(' ')
      },
      containedPrimary: {
        '&$disabled': {
          backgroundColor: palette.primary.light,
          color: palette.primary.lightContrastText
        }
      },
      containedSecondary: {
        '&$disabled': {
          backgroundColor: palette.secondary.light,
          color: palette.secondary.lightContrastText
        }
      },
      outlinedPrimary: {
        '&$disabled': {
          borderColor: palette.primary.light,
          color: palette.primary.light
        }
      },
      outlinedSecondary: {
        '&$disabled': {
          borderColor: palette.secondary.light,
          color: palette.secondary.light
        }
      }
    }
  }
});
var _default = theme;
exports.default = _default;